import { useAuth } from '../useAuth/useAuth'
import { useQuery } from '../useQuery/useQuery'
import { useRewardRulesConfiguration } from '../useRewardRulesConfiguration/useRewardRulesConfiguration'

import { Money } from '@percent/utility'
import { simulateAccountRewards } from '@percent/workplace-giving/api/gamification/simulateAccountRewards/simulateAccountRewards'
import {
  RewardRuleSimulation,
  SimulatedTimeLog
} from '@percent/workplace-giving/api/gamification/simulateAccountRewards/simulateAccountRewards.types'
import {
  getAccountConfigFromAuthState,
  getPartnerFromAuthState
} from '@percent/workplace-giving/context/auth/authContextController/AuthContextController'

export const MAX_SIMULATED_TIME_LOGS = 50

export const toSimulatedReward = (ruleId: string, simulations: readonly RewardRuleSimulation[]): Money | null => {
  const rewards = simulations.find(simulation => simulation.ruleId === ruleId && simulation.supported)?.rewards ?? []
  const [firstReward] = rewards
  const amount = rewards.reduce((total, reward) => total + reward.amount.amount, 0)

  return firstReward && amount > 0 ? { amount, currency: firstReward.amount.currency } : null
}

export function useSimulatedVolunteeringReward(timeLogs: readonly SimulatedTimeLog[]) {
  const { state: authState } = useAuth()
  const currency =
    getAccountConfigFromAuthState(authState)?.currency ?? getPartnerFromAuthState(authState)?.currencyCode ?? undefined
  const { data: configuration } = useRewardRulesConfiguration()
  const rule = configuration?.status === 'configured' ? configuration.configuration : null
  const canSimulate = timeLogs.length > 0 && timeLogs.length <= MAX_SIMULATED_TIME_LOGS
  const params = rule && canSimulate && currency ? { currency, timeLogs } : null

  const { data } = useQuery(['simulateAccountRewards', params], simulateAccountRewards, {
    staleTime: 1000 * 60,
    enabled: !!params
  })

  return {
    rule,
    reward: rule && data ? toSimulatedReward(rule.ruleId, data) : null
  }
}
